import * as classnames from 'classnames'
import * as React from 'react'

import CollectionIcon from '../../../../shared/components/icons/collection'
import CircleButton from '../circleButton'

import * as styles from './collectionButton.module.css'

interface IProps {
  href: string
  onClick: (event: any) => void
  isActive?: boolean
  className?: string
}

const CollectionButton = ({
  href,
  onClick,
  isActive = false,
  className = ''
}: IProps) => {
  const classes = classnames({
    [styles.linkActive]: isActive,
    [className]: !!className
  })

  return (
    <CircleButton
      href={href}
      className={classes}
      onClick={onClick}
      title="Add to Collection"
      rel="nofollow"
    >
      <CollectionIcon width="20" height="16" className={styles.icon} />
    </CircleButton>
  )
}

export default CollectionButton
